export enum Action {
  SET_ACCOUNTS = 'SET_ACCOUNTS',
  SET_IS_ACTIVE = 'SET_IS_ACTIVE',
  SET_PAGE = 'SET_PAGE',
  SET_SEARCH = 'SET_SEARCH',
  SET_FILTERS = 'SET_FILTERS',
  REMOVE_FILTER = 'REMOVE_FILTER',
}

export const PAGE_SIZE = 20;
export const MORE_PAGES = -1;

export const CALENDAR_OPTIONS = [
  {
    label: 'BrainHi',
    value: '0',
  },
  {
    label: 'Open Dental',
    value: '1',
  },
  {
    label: 'SecureClaim',
    value: '2',
  },
  {
    label: 'Practice Fusion',
    value: '3',
  },
  {
    label: 'ProClaim (Assertus)',
    value: '4',
  },
  {
    label: 'Chirotouch',
    value: '5',
  },
];
export const FILTER_OPTIONS = [
  {
    label: 'Calendar type',
    value: 'calendar_type',
  },
  {
    label: 'Has Scheduling Enabled',
    value: 'scheduling_enabled',
  },
  {
    label: 'Has Cancelations Enabled',
    value: 'cancelations_enabled',
  },
  {
    label: 'Has Confirmations Enabled',
    value: 'confirmations_enabled',
  },
  {
    label: 'Has Calendar Sync Enabled',
    value: 'calendar_sync_enabled',
  },
  {
    label: 'Has Waiting List Enabled',
    value: 'is_waiting_list_enabled',
  },
  {
    label: 'Has SMS Language Detection Enabled',
    value: 'sms_language_detection_enabled',
  },
  {
    label: 'Is Out of Sync',
    value: 'is_out_of_sync',
  },
];

export const FILTER_OPTION_TO_JSON: {
  [key: string]: { type: string; options?: { label: string; value: string }[] };
} = {
  calendar_type: { type: 'select', options: CALENDAR_OPTIONS },
  scheduling_enabled: { type: 'boolean' },
  cancelations_enabled: { type: 'boolean' },
  confirmations_enabled: { type: 'boolean' },
  calendar_sync_enabled: { type: 'boolean' },
  is_waiting_list_enabled: { type: 'boolean' },
  sms_language_detection_enabled: { type: 'boolean' },
  is_out_of_sync: { type: 'boolean' },
};
